var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDataAugmentationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Data-Augmentation-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 84.162,
    height: 73.247,
    viewBox: "0 0 84.162 73.247",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_385",
    "data-name": "Path 385",
    d: "M38.725,4.08C28.915,4.08,19,7.552,19,14.153v4.182a49.313,49.313,0,0,1,5.26.526V14.153c0-1.71,5.5-4.839,14.465-4.839s14.465,3.156,14.465,4.839V41.322c0,1.42-3.84,3.787-10.257,4.55v5.26c8.232-.842,15.517-4.208,15.517-9.863V14.153C58.451,7.552,48.535,4.08,38.725,4.08Z",
    transform: "translate(25.711 -4.054)",
    fill: "#0072ce"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_386",
    "data-name": "Path 386",
    d: "M7.26,41.338V14.169c0-1.71,5.5-4.839,14.465-4.839s14.465,3.156,14.465,4.839v4.708a49.314,49.314,0,0,1,5.26-.526V14.169c0-6.628-9.915-10.1-19.725-10.1S2,7.568,2,14.169V41.338c0,5.681,7.285,9.021,15.517,9.889v-5.26C11.1,45.125,7.26,42.758,7.26,41.338Z",
    transform: "translate(-2 -4.07)",
    fill: "#0072ce"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_387",
    "data-name": "Path 387",
    d: "M32.1,10.85c-12.966,0-22.75,4.944-22.75,11.52V54.746c0,6.575,9.784,11.52,22.75,11.52s22.75-4.944,22.75-11.52V22.37c0-6.575-9.784-11.52-22.75-11.52ZM49.59,31.023c-2.236,2.63-8.995,5.26-17.49,5.26a38.11,38.11,0,0,1-10.52-1.368v3.84A42.949,42.949,0,0,0,32.1,39.991a33.559,33.559,0,0,0,17.49-4.1v8.206c-2.236,2.63-8.995,5.26-17.49,5.26A38.109,38.109,0,0,1,21.58,47.96V51.8A42.949,42.949,0,0,0,32.1,53.036a33.559,33.559,0,0,0,17.49-4.1v6.023c0,2.5-6.97,6.26-17.49,6.26s-17.49-3.761-17.49-6.26V22.37c0-2.5,6.97-6.26,17.49-6.26s17.49,3.761,17.49,6.26Z",
    transform: "translate(9.981 6.982)",
    fill: "#0072ce"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataAugmentationIcon);
export default __webpack_public_path__ + "static/media/Data-Augmentation-icon.75af32c251a979ca150aab6a8abdad13.svg";
export { ForwardRef as ReactComponent };